import { useEffect } from "react";

export function useSeo(title: string, description: string) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) {
      meta.setAttribute("content", description);
    }
  }, [title, description]);
}